import { Component, HostBinding, Inject, Injector, OnInit, PLATFORM_ID, SimpleChanges, ViewEncapsulation, Input, OnChanges } from '@angular/core';
import { CommonHeaderComponent } from '../common-header.component';
import { UpaService, UpaTarget } from '../../../services/upa.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'header-view-1',
  template: `
        <div class="header-wrapper" id="{{htmlId}}"
            [ngClass]="{'grow-background': shouldGrowBackground(), 'without-sbox': !hasSbox, 'withPill': hasMainTitle() && titlePillLogo}"
            [style.backgroundColor]="backgroundColor">
            <optional-link *ngIf="(backgroundPosition === 'DEFAULT' || screenType !== 'DESKTOP')" class="background-header" 
                          [link]="link" [scrollTarget]="scrollTarget" [upaTrackingData]="upaTrackingData" [newTab]="openLinkInNewTab">
                <div content class="-eva-3-valign background-wrapper">
                    <title-pill class="-eva-3-valign" *ngIf="hasMainTitle() && titlePillLogo && !titleInNavBar"
                            [data]="mainTitleModule?.data!"
                            [logo]="titlePillLogo"
                    ></title-pill>
                    <background-header *ngIf="backgroundModule?.data" [data]="backgroundModule!.data"
                                    [options]="{
                            resizeType: 'FIT',
                            imageHeight: 280,
                            imageWidth: 1680,
                            previewMode: 'image'
                        }">
                    >
                    </background-header>
                </div>
            </optional-link>

            <div class="header-content vertical-align-{{mainTitleModule?.data?.text_vertical_align}}" 
              [ngClass]="{'default': (backgroundPosition === 'DEFAULT' || screenType !== 'DESKTOP'), 
                'next-to-shifu': isSboxNextToShifu, 
                'no-full-width' : this.hasSbox && !isSboxNextToShifu}">
                
                <optional-link *ngIf="(backgroundPosition === 'DEFAULT' || screenType !== 'DESKTOP') && hasMainTitle() && !this.titlePillLogo && !titleInNavBar" [link]="link" [scrollTarget]="scrollTarget" [upaTrackingData]="upaTrackingData" [newTab]="openLinkInNewTab">
                  <main-title content [data]="mainTitleModule?.data!" [ngClass]="{shadow: textShadow}" [moduleId]="module.id" [uniqueId]="module.unique_id" defaultColor="white"></main-title>
                </optional-link>
                <sbox [ngClass]="{'-eva-3-mt-lg -eva-3-mb-lg': !hasMainTitle() && !hasImage(), 'no-full-width': !isSboxNextToShifu}" *ngIf="hasSbox"
                    [sboxModule]="sboxModule" [modulePosition]="position" [moduleId]="'HeadingModule'" [uniqueId]="module.unique_id" [nextToShifu]="isSboxNextToShifu"></sbox>

                <optional-link class="main-title-below-sbox" *ngIf="(backgroundPosition === 'BELOW_SBOX' && screenType === 'DESKTOP') && hasMainTitle() && !this.titlePillLogo && !titleInNavBar" [link]="link" [scrollTarget]="scrollTarget" [upaTrackingData]="upaTrackingData" [newTab]="openLinkInNewTab">
                  <main-title content [data]="mainTitleModule?.data!" [ngClass]="{shadow: textShadow}" [moduleId]="module.id" [uniqueId]="module.unique_id" defaultColor="white" [titleColor]="mainTitleModule?.data?.title?.color"></main-title>
                </optional-link>
            </div>

            <div *ngIf="hasSbox && screenType === 'MOBILE'" id="sboxContainer"></div>

            <div *ngIf="backgroundPosition === 'BELOW_SBOX' && screenType === 'DESKTOP'">
                <background-header [data]="backgroundModule!.data"
                [options]="{
                            resizeType: 'FIT',
                            imageHeight: 280,
                            imageWidth: 1680,
                            previewMode: 'image'
                        }">
                </background-header>
            </div>

            <eva-subnav *ngIf="subnavModule" [viewType]="subnavViewType" [subnav]="subnavModule" [product]="'nymeria-gui'" [flow]="flow" (onClickSubnavItem)="trackUpa($event)"></eva-subnav>
        </div>
    `,
  styleUrls: ['./header-view-1.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeaderView1Component extends CommonHeaderComponent implements OnInit, OnChanges {
  @HostBinding('style.--background-min-height') backgroundMinHeight = '280px';
  @HostBinding('style.--background-max-height') backgroundMaxHeight = 'initial';
  @HostBinding('style.--title-max-width') titleMaxWidth = '100%';
  @HostBinding('style.--mobile-background-min-height') mobileBackgroundMinHeight = 'initial';

  @Input() openLinkInNewTab: boolean = false;

  isSboxNextToShifu: boolean = false;
  isAboveTheFold: boolean = false;
  hasSbox: boolean = false;

  constructor(injector: Injector,
    private upaService: UpaService,

    @Inject(PLATFORM_ID) private platformId: string
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (isPlatformBrowser(this.platformId)) {

      if (changes.shifuProduct?.currentValue) {

        super.updateData();
        this.initDimensions();
      }
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initDimensions();
    this.isAboveTheFold = this.landingModelService.getLandingModel().abTests?.tests?.NymeriaAboveTheFold?.branch == 'test';
    this.hasSbox = this.sboxModule !== undefined && (this.screenType != 'MOBILE' || this.flow != 'home');
    this.isSboxNextToShifu = this.backgroundPosition === 'BELOW_SBOX' && this.screenType === 'DESKTOP';
  }

  initDimensions() {
    const defaultMinWidth = !this.sboxModule ? '230px' :
      !this.hasImage() && !this.hasMainTitle() ? 'initial' : '280px';
    this.backgroundMinHeight = this.backgroundModule?.data?.css_options?.['min-height'] || defaultMinWidth;
    this.backgroundMaxHeight = this.backgroundModule?.data?.css_options?.['max-height'] || 'initial';
    this.titleMaxWidth = this.mainTitleModule?.data?.css_options?.['max-width'] || '100%';
    this.mobileBackgroundMinHeight = this.backgroundModule?.data?.css_options?.['mobile-min-height'] || 'initial';
  }

  hasMainTitle(): boolean {
    return !!(this.mainTitleModule?.data &&
      (this.mainTitleModule.data.title?.text
        || this.mainTitleModule.data.pre_title?.text
        || this.mainTitleModule.data.sub_title?.text
      ));
  }

  shouldGrowBackground() {
    return !this.hasMainTitle() && this.hasImage() || this.titlePillLogo;
  }

  hasImage(): boolean {
    return !!(this.backgroundModule?.data?.picture || this.backgroundModule?.data?.picture_mobile);
  }

  trackUpa($event) {

    this.module.data.subnav.items.forEach((item, index) => {
      if (item.target.value == $event.value) {
        this.upaService.trackClickTopic({
          label: item.title,
          positionIndex: index,
          moduleId: this.module.id,
          moduleIndex: this.module.position,
          target: UpaTarget.HEADING,
          uniqueId: this.module.unique_id
        })
      }
    });
  }

}